import {transportCategories, TransportCategory} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<TransportCategory>;

export const TransportCategorySelect = (props: Props) => {
  const {options = transportCategories, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
